export const ROUTER_BASENAME: string = (() => {
  if (typeof window === 'undefined') return '';
  const path = window.location.pathname;
  if (path === '/driver' || path.startsWith('/driver/')) return '/driver';
  return '';
})();
